import axios, { AxiosInstance } from "axios";
import { api, emailMobileCheck } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";
import { attachRefreshInterceptor } from "src/utils/axiosRefreshInterceptor";

let instance: AxiosInstance;
// let eventInstance: AxiosInstance;

const axiosInstance = async () => {
  instance = axios.create({
    baseURL: api + "/api/v1/common",
  });
  // Attach 403 refresh-and-retry interceptor
  attachRefreshInterceptor(instance);

  instance.interceptors.request.use((config) => addAuthHeader(config));
};

axiosInstance();

interface ApiResponse {
  success: boolean;
  message: string;
  data?: any;
  status: number | string;
  // Add other properties as needed
}

export const checkMobileNo = async (mobileNo: string) => {
  // return instance.get(`/check-mobile?mobile=${mobileNo}`);
  return axios.get(`${emailMobileCheck}?mobile_no=${mobileNo}`);
};

export const checkEmail = async (email: string) => {
  return axios.get(`${emailMobileCheck}?email=${email}`);

  // return instance.get(`/check-email?email=${email}`);
};

export const getCounterTypes = async (query?: string): Promise<ApiResponse> => {
  if (query) return instance.get("/getModuleTypes" + query);
  return instance.get("/getModuleTypes");
};
